import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import PasswordMessage from '../passwordMessage';
import Label from './common/label';

const Password = ({ labels, errors, touched }) => {
  return (
    <>
      <Label labelName={labels.PASSWORD} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.password && touched.password ? 'error' : ''
        }`}
      >
        <Field
          type="password"
          name="password"
          style={{ width: '100%' }}
          placeholder={labels.PLACEHOLDER_PASSWORD}
          className="select-style"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.password}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>

      <PasswordMessage />
    </>
  );
};

Password.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default Password;
